import {z} from 'zod';

import {emailSchema, phoneNumberSchema} from '../../account/schemas/authSchemas';

const REQUIRED_FIELD_MESSAGE = 'This is a required field';

export const selfExclusionSchema = z.object({
  firstName: z.string({message: REQUIRED_FIELD_MESSAGE}).min(1, REQUIRED_FIELD_MESSAGE),
  lastName: z.string({message: REQUIRED_FIELD_MESSAGE}).min(1, REQUIRED_FIELD_MESSAGE),
  email: emailSchema,
  phone: phoneNumberSchema.unwrap(),
});

export type SelfExclusionFormData = z.infer<typeof selfExclusionSchema>;
